import { render, staticRenderFns } from "./G_080_KojoDekidakaEntry_ChildHeaderInput.vue?vue&type=template&id=1f7ad222&"
import script from "./G_080_KojoDekidakaEntry_ChildHeaderInput.vue?vue&type=script&lang=ts&"
export * from "./G_080_KojoDekidakaEntry_ChildHeaderInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports